module.exports = __webpack_public_path__ + "img/obj.5a92be69.svg";